import React, { useEffect } from 'react';
import { Text, Title } from '@gjensidige/core-typography';
import { Col, Container, Row } from '@gjensidige/core-grid';
import styles from './layout.module.less';
import { Spacer } from '../Spacer/Spacer';
import { scroller } from 'react-scroll';
import { useLocation } from 'react-router-dom';
export const Layout = ({ title, subtitle, size, children, scrollToTop = true }) => {
    const location = useLocation();
    useEffect(() => {
        if (scrollToTop) {
            scroller.scrollTo('gpf-fkl-app', {
                duration: 500,
                delay: 50,
                smooth: 'easeInOutQuint',
            });
        }
    }, [location, scrollToTop]);
    return (React.createElement(Container, null,
        React.createElement(Spacer, { parent: 'none', child: 'lg' },
            React.createElement(Row, null,
                React.createElement(Col, { xl: { span: 8, offset: 2 }, lg: { span: 10, offset: 1 }, md: { span: 8, offset: 2 }, className: styles.header },
                    React.createElement(LayoutHeader, { title: title, subtitle: subtitle, size: size }))),
            React.createElement(Row, null,
                React.createElement(Col, { xl: { span: 6, offset: 3 }, md: { span: 8, offset: 2 }, className: styles.content }, children)))));
};
const LayoutHeader = ({ size, title, subtitle }) => {
    return (React.createElement("div", null,
        React.createElement(Title, { tag: size == 'small' ? 'h2' : 'h1', size: size == 'small' ? 'h4' : 'h1' }, title),
        subtitle && React.createElement(Text, null, subtitle)));
};
